var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":this.urlIframe + '/app/agent-crm',"allow":"microphone; camera","id":"iframe-diabolocom","name":"diabolocom-cti-iframe","width":"100%","height":"435"}})}
var staticRenderFns = []

export { render, staticRenderFns }